module.exports = __webpack_public_path__ + "img/work-card3.8f77ccea.png";